import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { PlannerValidation } from './PlannerValidation';
/**
 * Validates that all frames in a frame group have wall connectors to be able to
 * be placed on a wall
 */
export class FrameGroupWallPlacementValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'FrameGroupWallPlacementValidation');
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        if (snapActionCandidate.hostConnector.isOffering('wall') &&
            entity.hasComponent(ComponentIds.AUTOMATIC_ENTITY_GROUP_COMPONENT_ID)) {
            const frameChildren = HierarchyUtils.children(entity).filter(child => child.hasComponent(ComponentIds.FRAME_COMPONENT_ID));
            // Check that all frames in group have wall connectors
            return frameChildren.every(child => child
                .getComponent(ComponentIds.CONNECTORS_COMPONENT_ID)
                ?.connectors.some(connector => connector.demands().includes('wall')))
                ? this.validationOK()
                : this.validationFail('All frames in group must have wall connectors');
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=FrameGroupWallPlacementValidation.js.map